import {
  Route,
  Switch
} from "react-router-dom";
import Dashboard from "./components/Dashboard/Dashboard";
import Login from "./components/Login";
import Marketing from "./components/Marketing";
//import Profile from "./components/MyProfile/Profile";
import UserAndRoles from "./components/MyProfile/UserAndRoles";
import OpenOrders from "./components/Orders/OpenOrders";
import OrderDetail from "./components/Orders/OrderDetail";
import Orders from "./components/Orders/Orders";
import PendingOrders from "./components/Orders/PendingOrders";
import ProductDetails from "./components/Orders/ProductDetails";
import Shipments from "./components/Orders/Shipments";
import Payments from "./components/Payments";
import ResetForm from "./components/ResetForm";
import ShopForTyres from "./components/ShopForTyres";
// import "./App.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Claims from "./components/Claims/Claims";
import NewClaim from "./components/Claims/NewClaim";
import Transactions from "./components/Claims/Transactions";
import Warrenties from "./components/Claims/Warrenties";
import CreateBulk from "./components/CreateBulk";
import CustomerInfo from "./components/Customers/CustomerInfo";
import Customers from "./components/Customers/Customers";
import ProfomaDoc from "./components/Orders/ProfomaDoc";
import SignUp from "./components/SignUp";
import ThankQ from "./components/ThankYou";
import UploadInventory from "./components/UploadInventory";
// import ResetPasswordForm from "./components/ResetPassoword";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import CheckComponent from "../components/CheckComponent";
import Admins from "./components/Customers/Admins";
import PaymentDoc from "./components/PaymentDoc";
import ShipmentDoc from "./components/ShipmentDoc";

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const history = useHistory()
  useEffect(() => {
    const permissions = localStorage.getItem("permissions")


    if (!localStorage.getItem("is_super_admin") &&
      localStorage.getItem("token")) {
      history.push("/dashboard");
    }

    if (
      (rest.path.includes("/admin")) && rest.path !== "/admin/" &&
      !localStorage.getItem("token")
    ) {
      history.push(`/admin/${permissions ? permissions?.split(",")?.[0] : "customers"}`);
    }

    if (
      localStorage.getItem("is_super_admin") && permissions && !permissions?.includes(rest.path?.split("/")?.[-1]) &&
      localStorage.getItem("token")
    ) {
      history.push(`/admin/${permissions?.split(",")?.[0]}`);
    }
    // eslint-disable-next-line
  }, [])
  return (
    <Route {...rest} render={(props) => <Component {...rest} {...props} />} />
  );
};
function App() {
  return (
    <div className="App">

      <Switch>
        <ProtectedRoute exact path="/admin/reset-password" component={ResetForm} />
        {/* <ProtectedRoute
            exact
            path="/admin/reset_password"
            component={ResetPasswordForm}
          /> */}
        <ProtectedRoute exact path="/admin/thank-you" component={ThankQ} />
        <ProtectedRoute exact path="/admin/products" component={ShopForTyres} />
        <ProtectedRoute exact path="/admin/inventory" component={UploadInventory} />
        <ProtectedRoute exact path="/admin/marketing" component={Marketing} />
        <ProtectedRoute exact path="/admin/warranties" component={Warrenties} />
        <ProtectedRoute exact path="/admin/transactions" component={Transactions} />
        <ProtectedRoute exact path="/admin/dashboard" component={Dashboard} />
        <ProtectedRoute exact path="/admin/customers" component={Customers} />
        <ProtectedRoute exact path="/admin/admins" component={Admins} />
        <ProtectedRoute
          exact
          path="/admin/customer-info"
          component={CustomerInfo}
        />
        <ProtectedRoute
          exact
          path="/admin/product-detail"
          component={ProductDetails}
        />
        <ProtectedRoute exact path="/admin/order-detail" component={OrderDetail} />
        <ProtectedRoute exact path="/admin/orders" component={Orders} />
        <ProtectedRoute
          exact
          path="/admin/pending-actions"
          component={PendingOrders}
        />
        <ProtectedRoute exact path="/admin/claims" component={Claims} />
        <ProtectedRoute exact path="/admin/payments" component={Payments} />
        <ProtectedRoute exact path="/admin/open-orders" component={OpenOrders} />
        <ProtectedRoute exact path="/admin/sign-up" component={SignUp} />
        <ProtectedRoute exact path="/admin/track-shipments" component={Shipments} />
        <ProtectedRoute exact path="/admin/user-roles" component={UserAndRoles} />
        {/* <ProtectedRoute exact path="/admin/profile" component={Profile} /> */}
        <ProtectedRoute exact path="/admin/new-claim" component={NewClaim} />
        <ProtectedRoute exact path="/admin/create-bulk" component={CreateBulk} />
        <ProtectedRoute exact path="/admin/" component={Login} />
        <ProtectedRoute exact path="/admin/profoma-doc" component={ProfomaDoc} />
        <ProtectedRoute exact path="/admin/payment-doc" component={PaymentDoc} />
        <ProtectedRoute exact path="/admin/shipment-doc" component={ShipmentDoc} />
        <Route path="/admin/*" component={CheckComponent} />
      </Switch>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar
        closeOnClick
      />
    </div>
  );
}

export default App;
